import script from "./CommunityActivity.vue?vue&type=script&setup=true&lang=js"
export * from "./CommunityActivity.vue?vue&type=script&setup=true&lang=js"

import "./CommunityActivity.vue?vue&type=style&index=0&id=12742b0f&lang=scss"

const __exports__ = script;

export default __exports__